import React, { useState, useEffect } from 'react';
import { SimpleContactModal } from './SimpleContactModal';

interface QuickActionsProviderProps {
  children: React.ReactNode;
  enableContactModal?: boolean;
  enableJobModal?: boolean;
  onContactCreated?: (contact: any) => void;
  onJobCreated?: () => void;
}

export const QuickActionsProvider: React.FC<QuickActionsProviderProps> = ({
  children,
  enableContactModal = true,
  enableJobModal = false,
  onContactCreated,
  onJobCreated,
}) => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  useEffect(() => {
    console.log('QuickActionsProvider useEffect triggered');
    console.log('enableContactModal:', enableContactModal);
    console.log('window.QuickActions:', window.QuickActions);
    
    const registerModals = () => {
      // Register Quick Actions handlers with global window object
      if (window.QuickActions) {
        if (enableContactModal) {
          console.log('Registering contact modal handler');
          window.QuickActions.registerContactModal(() => {
            console.log('Contact modal handler called from QuickActionsProvider');
            setIsContactModalOpen(true);
          });
        }
        return true; // Registration successful
      }
      return false; // Registration failed
    };

    // Try to register immediately
    if (!registerModals()) {
      // If QuickActions API isn't ready, retry after a short delay
      console.log('QuickActions API not ready, retrying in 50ms...');
      const retryTimeout = setTimeout(() => {
        if (registerModals()) {
          console.log('Delayed registration successful');
        } else {
          console.warn('QuickActions API still not available after retry');
        }
      }, 50);
      
      // Cleanup timeout if component unmounts
      return () => {
        clearTimeout(retryTimeout);
        if (window.QuickActions && enableContactModal) {
          console.log('Unregistering contact modal handler');
          window.QuickActions.unregisterContactModal();
        }
      };
    }

    // Cleanup on unmount
    return () => {
      if (window.QuickActions) {
        if (enableContactModal) {
          console.log('Unregistering contact modal handler');
          window.QuickActions.unregisterContactModal();
        }
      }
    };
  }, [enableContactModal, enableJobModal]);

  const handleContactSuccess = (contact: any) => {
    onContactCreated?.(contact);
    setIsContactModalOpen(false);
  };

  return (
    <>
      {children}
      
      {enableContactModal && (
        <SimpleContactModal
          open={isContactModalOpen}
          onClose={() => setIsContactModalOpen(false)}
          onSuccess={handleContactSuccess}
        />
      )}
    </>
  );
};